<template>
  <hgroup class="mt-6 mb-4">

    <h1 class="subtitle"><DeviceId :id="n.deviceId" :display-as="displayAs" /></h1>
    
    <b-field grouped group-multiline>
      
      <p v-if="policyRule" class="control">
        <TagComponent @click="filterByPolicy" hint="Policy assignment" textVariant="info" :text="policyRule" icon="atom"/>
      </p>

      <p class="control">
        <TagComponent v-if="appVariation" :hint="`${packageName} v${mobileVersionFull}`" textVariant="primary" :text="`${appVariation} v${mobileVersion}`" :icon="['fab', 'app-store']"/>
      </p>

      <!-- groups -->
      <p class="control">
        <b-taglist>
          <TagComponent v-for="group in (n.metaData.groups || [])" :key="group"
            @click="filterByGroup"
            light variant="info"
            hint="Group membership" :text="group" icon="tag"
            />
        </b-taglist>
      </p>
      <!-- eo:groups -->
      
    </b-field>
  </hgroup>
</template>

<script>
import { knownMobileModel } from '@/services/devices'
export default {
  props: {
    n: Object
  },
  computed: {
    meta () { return this.n.metaData },
    policyRule () { return this.meta['project-name'] },
    appVariation () { return this.meta['apk-profile'] },
    packageName () { return this.meta['apk-packageName'] },
    mobileVersion () { return this.meta['apk-version-name'] },
    mobileVersionFull () { return `${this.mobileVersion}-${this.meta['apk-version-code']}` },
    deviceModel () { return knownMobileModel(this.meta['device-model']) },
    displayAs () {
      if ('device-manufacturer' in this.meta && 'device-model' in this.meta) {
        return `${this.meta['device-manufacturer']} ${this.deviceModel}`
      }
      return null
    }
  },
  methods: {
    backToSearch () {
      if (this.$route.name !== 'search') {
        this.$router.push({ name: 'search' })
      }
    },
    filterByGroup (group) {
      const groups = this.$store.state.filters.groups || []
      if (!groups.includes(group)) {
        this.$store.commit('filters/setGroups', [ ...groups, group ])
        this.backToSearch()
      }
    },
    filterByPolicy () {
      this.$store.commit('filters/setPolicySet', this.policyRule)
      this.backToSearch()
    }
  }
}
</script>